export default __webpack_public_path__ + "static/cherry_site_logo_rebrand-b06c33c89b9a9d42d909da0de7c1ce79.png";